// extracted by mini-css-extract-plugin
module.exports = {"container":"NoPermissions_container__3fSwz","header":"NoPermissions_header__u-KFp","text":"NoPermissions_text__Tigb2"};